import $ from 'jquery'
export const SEPARATE_WITH_SPAN = {
  init: function () {
    const $element = $('.js-separate')
    $element
      .children()
      .addBack()
      .contents()
      .each(function () {
        if (this.nodeType === 3) {
          const $this = $(this)
          $this.replaceWith($this.text().replace(/(\S)/g, '<span>$&</span>'))
        }
      })
  },
}
